module.exports = __webpack_public_path__ + "media/WR Blob 1.33c00c9d.mp3";